<template>
  <SecondaryButton :loading="isExporting" @click="exportStores">
    <DownloadIcon v-if="!isExporting" class="h-4 w-4 mr-2" />
    {{ t("export_button") }}
  </SecondaryButton>
</template>

<script>
import { mapActions } from "vuex";
import { useI18n } from "vue-i18n";
import { SecondaryButton, download } from "@estaly/ui";
import { DownloadIcon } from "@heroicons/vue/outline";

export default {
  components: { SecondaryButton, DownloadIcon },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      isExporting: false,
    };
  },

  methods: {
    ...mapActions("stores", ["exportXlsx"]),

    async exportStores() {
      this.isExporting = true;
      try {
        const response = await this.exportXlsx();
        if (!response?.success) return;

        // Date locale (et non UTC) au format AAAA-MM-JJ
        const today = new Date().toLocaleDateString("sv-SE");
        download(response.data, `points-de-vente-${today}.xlsx`);
      } finally {
        this.isExporting = false;
      }
    },
  },
};
</script>

<i18n src="./StoreExportButton.i18n.json"></i18n>
